import apiClient from '../api/client';
import { ApiResponse } from '../../types/api.types';

export interface PublicTestimonial {
  id: number;
  name: string;
  text: string;
  rating: number;
  location: string | null;
  profile: string | null;
  category: string | null;
  status: string;
  verified: boolean | number;
  featured: boolean | number;
  helpful: number;
  created_at: string;
  updated_at: string | null;
}

export interface PublicTestimonialListResponse {
  testimonials: PublicTestimonial[];
  pagination: {
    total: number;
  };
}

class TestimonialService {
  /**
   * Make public API call (with optional auth header)
   */
  private async makePublicCall<T>(url: string, config: any = {}): Promise<T> {
    try {
      const response = await apiClient.get<ApiResponse<T>>(url, config);
      
      if (!response.data || !response.data.data) {
        throw new Error('Invalid API response structure');
      }
      
      return response.data.data;
    } catch (error: any) {
      console.error('Public API call failed:', url, error);
      throw error;
    }
  }

  /**
   * Get All Approved Testimonials (Public)
   * GET /api/testimonials
   */
  async getAllTestimonials(): Promise<PublicTestimonialListResponse> {
    try {
      const data = await this.makePublicCall<PublicTestimonialListResponse>(
        '/api/testimonials'
      );
      
      // Convert verified and featured to boolean for consistency
      if (data && data.testimonials) {
        data.testimonials = data.testimonials.map((testimonial: any) => ({
          ...testimonial,
          verified: Boolean(testimonial.verified),
          featured: Boolean(testimonial.featured),
        }));
      }
      
      return data;
    } catch (error: any) {
      console.error('Error in getAllTestimonials:', error);
      throw error;
    }
  }
}

export default new TestimonialService();
